import { call, put, select, takeLatest } from "redux-saga/effects";

import { getMoneys } from "services/money.service";

import { setData, setLoading } from "./activity-list.action";
import { Types } from "./activity-list.constant";
import { paramsSelector } from "./activity-list.selector";

import { pushErrorMessage } from "../snackbar/snackbar.action";

function* watchLoadData() {
  try {
    yield put(setLoading(true));

    // @ts-ignore
    const params = yield select(paramsSelector);

    const { count, data } = yield call(getMoneys, params);

    yield put(setData(count, data));
  } catch (e) {
    yield put(pushErrorMessage(e));
    yield put(setData(0, []));
  }
}

export default function* root() {
  yield takeLatest(Types.LOAD_DATA, watchLoadData);
}
